import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import React from 'react';
import { Controller } from 'react-hook-form';


interface props extends CheckboxProps {
    onChange?: (event: any) => void,
    name: string,
    label: string,
    disable?: boolean,
    control: any,
    paddingtop?: number,
}

export default function CheckboxUI(props: props) {
    return (
        <FormControl disabled={props.disable} component="fieldset">
            <FormGroup style={{ paddingTop: props.paddingtop ? props.paddingtop : 20 }}>
                <FormControlLabel
                    disabled={props.disable}
                    name={props.name}
                    control={
                        <Controller
                            name={props.name}
                            control={props.control}
                            render={({ field }) => (                   
                                <Checkbox {...props} 
                                    checked={field.value} 
                                    color="primary" 
                                    onChange={(e) => {
                                        if (props.onChange){
                                            props.onChange(e)
                                        }
                                        field.onChange(e.target.checked)
                                    }}
                                />
                            )}
                        />                            
                    }
                    label={props.label}
                    labelPlacement="end"
                />
            </FormGroup>
        </FormControl>
    );
}
